export default __webpack_public_path__ + "static/media/forcemanager-icon.ec004fe3.png";